<div class="layout-topbar">
  <a class="layout-topbar-logo" [routerLink]="['/ds/home']">
    <!--<img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.svg" alt="logo">-->
    <img src="../../../../assets/images/logo_klaus_light_blue.svg" alt="Klaus versichert">
    <!--<span>SAKAI</span>-->
  </a>

  <button #menubutton class="p-link layout-menu-button layout-topbar-button collapse-btn"
          (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
  </button>

  <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
          (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div #topbarmenu class="layout-topbar-menu flex-row-reverse"
       [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
    <!--
    <button class="p-link layout-topbar-button">
        <i class="pi pi-calendar"></i>
        <span>Calendar</span>
    </button>
    -->
    <button class="p-link layout-topbar-button" [routerLink]="['/ds/us/profile']">
<!--      <i class="pi pi-user"></i>-->
      <div class="flex justify-content-center align-content-center border-circle lg:mr-0 mr-2">
        <img [src]="userProfilePhoto ?? 'assets/images/blank_user.png'"
             class="w-2rem h-2rem m-auto border-circle" style="object-fit: contain"/>
      </div>
      <span>Profil</span>
    </button>
    <button class="p-link layout-topbar-button" [routerLink]="['/ci/service/contactUs']">
      <i class="pi pi-comment"></i>
      <span>Kontaktiere uns</span>
    </button>
    <button (click)="handleLogoutDialog()" class="p-link layout-topbar-button text-red-400">
      <i class="pi pi-power-off text-red-500"></i>
      <span>Abmelden</span>
    </button>
  </div>
</div>

<p-dialog [(visible)]="logoutDialog" [modal]="true"
          [style]="{width: '45rem'}" [closable]="false" [resizable]="false">

  <div class="surface-card border-round-2xl w-full">

    <div class="flex justify-content-center mb-4">
        <span class="w-5rem h-5rem border-circle flex justify-content-center align-items-center bg-red-100">
          <i class="pi pi-sign-out text-red-600 text-5xl"></i>
        </span>
    </div>

    <div class="text-center mb-5">
      <div class="text-color text-3xl font-semibold mb-2">Abmelden</div>
      <span class="text-600 font-medium line-height-3 text-color-secondary">Sind Sie sicher, dass Sie sich abmelden möchten?</span>
    </div>

    <p-divider></p-divider>

    <div class="flex justify-content-end gap-3">

      <p-button label="Abbrechen" [text]="true" (click)="onHideDialog()"></p-button>
      <p-button label="Abmelden" (click)="handleLogout()" severity="danger"></p-button>

    </div>

  </div>

</p-dialog>
